import React from "react";
import { useApp } from "../context/AppContext";

function Footer() {
  const { t, lang } = useApp();
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-top">
          <span>{t("connected")}</span>
          <div className="footer-social">
            <a href="https://www.facebook.com/sudanese.plastic.artist.union" target="_blank" rel="noreferrer" title="Facebook"><i className="fa-brands fa-facebook" /></a>
            <a href="https://twitter.com/ArtistsRally"        target="_blank" rel="noreferrer" title="X/Twitter"><i className="fa-brands fa-x-twitter"  /></a>
            <a href="https://www.instagram.com/spar.sudan/"   target="_blank" rel="noreferrer" title="Instagram"><i className="fa-brands fa-instagram"  /></a>
            <a href="https://www.youtube.com/@SudanesePlasticArtistsRa-oh2zd/featured" target="_blank" rel="noreferrer" title="YouTube"><i className="fa-brands fa-youtube" /></a>
            <a href="https://spar-sudan.blogspot.com/"         target="_blank" rel="noreferrer" title="Blog"    ><i className="fa-solid fa-blog"         /></a>
          </div>
        </div>

        <div className="footer-cols">
          <div>
            <img src="/Logoithad.jpg" alt="SPAU" style={{ width:90, marginBottom:14, borderRadius:8 }} />
            <h6>{lang==="ar" ? "الاتحاد العام للفنانين التشكيليين السودانيين" : "Sudanese Plastic Artists Union"}</h6>
            <p>{lang==="ar"
              ? "يهدف الاتحاد إلى تعزيز الفن التشكيلي في السودان، وإبراز دور الفنون في المجتمع، وتوسيع شبكة التواصل بين الفنانين السودانيين وفنانين العالم."
              : "Promoting plastic art in Sudan, highlighting the role of arts in society, and expanding the network between Sudanese artists and the world."
            }</p>
          </div>

          <div>
            <h6>{lang==="ar" ? "مكاتب الاتحاد" : "Union Offices"}</h6>
            <ul>
              <li><a href="#">{lang==="ar" ? "مكتب التنظيم والعضوية" : "Organisation & Membership"}</a></li>
              <li><a href="#">{lang==="ar" ? "المكتب الأكاديمي" : "Academic Office"}</a></li>
              <li><a href="#">{lang==="ar" ? "مكتب النقابة" : "Union Office"}</a></li>
              <li><a href="#">{lang==="ar" ? "مكتب التوجيه السياسي" : "Political Guidance Office"}</a></li>
            </ul>
          </div>

          <div>
            <h6>{t("usefulLinks")}</h6>
            <ul>
              <li><a href="https://www.sudanmemory.org/cms/120/"               target="_blank" rel="noreferrer">{lang==="ar"?"ذاكرة السودان":"Sudan Memory"}</a></li>
              <li><a href="http://lessedra.com/previous.php?exh_id=45"          target="_blank" rel="noreferrer">{lang==="ar"?"جمعية الفنانات السودانيات":"Women Artists Association — Sudan"}</a></li>
              <li><a href="https://www.arabculturefund.org/Grantees/1003"       target="_blank" rel="noreferrer">{lang==="ar"?"صندوق الثقافة العربي":"Arab Culture Fund"}</a></li>
              <li><a href="https://sharjahart.org/"                             target="_blank" rel="noreferrer">{lang==="ar"?"مؤسسة الشارقة للفنون":"Sharjah Art Foundation"}</a></li>
              <li><a href="https://nationalgallery.org/artist/hussein-hadi-m-noor/" target="_blank" rel="noreferrer">{lang==="ar"?"المعرض الوطني الأردني":"Jordan National Gallery"}</a></li>
            </ul>
          </div>

          <div>
            <h6>{t("contact")}</h6>
            <p><i className="fa-solid fa-location-dot" /> &nbsp;{lang==="ar"?"الخرطوم، السودان — ص.ب. ١٠٠١٢":"Khartoum, Sudan — PO Box 10012"}</p>
            <p><i className="fa-solid fa-envelope" /> &nbsp;<a href="mailto:spau.artists@gmail.com">spau.artists@gmail.com</a></p>
            <p><i className="fa-solid fa-globe" /> &nbsp;<a href="https://spar-sudan.blogspot.com/" target="_blank" rel="noreferrer">spar-sudan.blogspot.com</a></p>
            <p style={{ marginTop:16 }}>
              <a href="/register" className="btn btn-primary" style={{ fontSize:"0.85rem", padding:"9px 18px" }}>
                <i className="fa-solid fa-palette" /> {t("join")}
              </a>
            </p>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} {lang==="ar" ? "الاتحاد العام للفنانين التشكيليين السودانيين" : "Sudanese Plastic Artists Union"}. {lang==="ar" ? "جميع الحقوق محفوظة." : "All rights reserved."}</span>
        <span style={{ opacity: 0.55, display: "block", marginTop: 4, fontSize: "0.78rem" }}>{lang==="ar" ? "تصميم وتطوير: أمجد حجازي" : "Designed & built by Amged Higazi"}</span>
      </div>
    </footer>
  );
}
export default Footer;
